/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import useBaseService from '../../../hooks/services/useBaseService'
import useLoader from '../../../hooks/useLoader'
import useNotification from '../../../hooks/useNotification'
import { entities } from '../../../constants/entities'
import MainLayout from '../../../layouts/MainLayout'
import PageHeader from '../../../components/PageHeader'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import useForm from '../../../hooks/useForm'
import { setDefaultFieldValues } from '../../../utils/objectUtils'
import SimpleBody from '../../../components/forms/SimpleBody'
import SectionHeader from '../../../components/forms/SectionHeader'
import Form from '../../../components/forms/Form'
import { filterFields } from './filters'
import Button from '../../../components/Button'
import { Alert, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useOrgan } from '../../../hooks/useOrgan'
import { useReport } from '../../../context/ReportContext'

const PerformaceTechnicians = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { selectedOrgan } = useOrgan()

  const { setExportId, isExporting } = useReport()

  const [filtersSection] = filterFields
  const { formData, handleChange } = useForm(
    setDefaultFieldValues([filtersSection]),
    [filtersSection]
  )

  // Se ao menos um tiver preenchido marcar como true
  const [hasFilled, setHasFilled] = useState(false)

  useEffect(() => {
    const hasFilledValidate = formData.filter.period
    setHasFilled(hasFilledValidate)
  }, [formData])

  const { post: baseServicePost } = useBaseService(navigate)
  const { hideLoader, showLoader } = useLoader()
  const { showNotification } = useNotification()

  const exportReport = useMutation({
    mutationFn: async (payload) => {
      showLoader()
      const response = await baseServicePost(
        entities.reports.performance.get,
        payload
      )
      return response
    },
    onMutate: () => {
      showLoader()
    },
    onSuccess: (response) => {
      if (response?.status === 202 || response?.status === 200) {
        const generated_id = response.result?.export_id

        if (generated_id) {
          setExportId(generated_id)
          localStorage.setItem('report_exportId', generated_id.toString())
          showNotification(
            'info',
            'Processamento do relatório iniciado em segundo plano.'
          )
        }
      }
    },
    onError: (error) => {
      console.error('onError ', error)
      hideLoader()

      // Pega a mensagem do backend (axios / fetch estruturam diferente)
      const message =
        error?.response?.data?.message ||
        error?.result?.message ||
        error?.message ||
        ''

      // Se for o caso de "sem manutenções", mostra como aviso amigável
      if (message.toLowerCase().includes('nenhuma manutenção encontrada')) {
        showNotification(
          'warning',
          '⚠️ Nenhuma manutenção encontrada para a data informada. Verifique o período e tente novamente.'
        )
        return
      }

      // Qualquer outro erro mantém o comportamento atual
      showNotification(
        'error',
        message || 'Erro inesperado ao gerar o relatório. Tente novamente.'
      )
    },
    onSettled: () => {
      hideLoader()
    },
  })

  useEffect(() => {
    if (location.state?.message) {
      showNotification('error', location.state.message)
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [location.state, showNotification, navigate, location.pathname])

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader title="Produção dos técnicos" showBackButton={false} />
      <Alert
        severity="info"
        sx={{
          mb: 2,
        }}>
        <strong>Atenção:</strong> Esse relatório mostra a produção dos técnicos
        conforme a data de produção.
      </Alert>
      <div className="container-fluid p-1">
        <Form
          initialFormData={formData}
          onSubmit={() => {}}
          textSubmit="Filtrar"
          textLoadingSubmit="Filtrando..."
          showButtons={false}
          disabledSubmitButton={true}>
          {() => (
            <>
              <div key={filtersSection.section}>
                <SectionHeader section={filtersSection.section} />

                <SimpleBody
                  fields={filtersSection.fields}
                  formErrors={{}}
                  formData={formData}
                  handleFieldChange={handleChange}
                  getOptions={() => {}}
                  getSelectedValue={() => {}}
                />
              </div>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  my: 4,
                  width: '100%',
                }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="button"
                  startIcon={<FontAwesomeIcon icon={faFileExcel} />}
                  text="Exportar em EXCEL"
                  disabled={!hasFilled || isExporting}
                  onClick={async () => {
                    try {
                      const payload = {
                        period: formData.filter.period,
                        organization_id: selectedOrgan.id,
                      }
                      await exportReport.mutateAsync(payload)
                    } catch (error) {
                      console.error('Erro ao exportar EXCEL:', {
                        status: error.status,
                        message: error.message,
                      })
                    }
                  }}
                />
              </Box>
            </>
          )}
        </Form>
      </div>
    </MainLayout>
  )
}

export default PerformaceTechnicians
